import { Button, Dialog, Dropdown, Field } from 'Components/Core';
import { ISelectOption } from 'Components/Core/Dropdown/types';
import { ListFieldSection } from 'Components/Layout';
import { LaboratoryDropdown } from 'Components/List';
import { actions } from 'Data/ReduxViewModels/Admin';
import { Guid } from 'guid-typescript';
import { isNull } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IDialogAddLaboratoryParams } from '../types';

const AgsExportConfigurationAddLaboratoryDialogAdmin: React.FC<IDialogAddLaboratoryParams> = ({
  dialogVisibleState,
  asgConfigurationListOptions,
  onClose,
}) => {
  const dispatch = useDispatch();
  const addNewLaboratoryMapping = () => {
    dispatch(
      actions.addAgsLaboratoryMapping({ labId: choosenLaboratory, configurtionId: choosenAgsConfiguration?.value })
    );
    setSaving(true);
  };

  const addingElement: boolean = useSelector((state: any) => state.admin.agsExportConfiguration.laboratory.adding);
  const [choosenLaboratory, setChoosenLaboratory] = useState<Guid | null>(null);
  const [choosenAgsConfiguration, setChoosenAgsConfiguration] = useState<ISelectOption | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (saving && !addingElement) {
      setSaving(false);
      onClose();
      setChoosenLaboratory(null);
      setChoosenAgsConfiguration(null);
    }
  }, [addingElement, onClose, saving]);

  const onDialogClose = () => {
    onClose();
    setChoosenLaboratory(null);
    setChoosenAgsConfiguration(null);
  };

  const dialogButtons = [
    <Button
      primary
      onClick={addNewLaboratoryMapping}
      disabled={isNull(choosenLaboratory) || isNull(choosenAgsConfiguration) || saving}
      loading={saving}
    >
      Add
    </Button>,
    <Button onClick={onDialogClose} disabled={saving}>
      Cancel
    </Button>,
  ];

  return (
    <Dialog
      onClose={onDialogClose}
      visible={dialogVisibleState}
      buttons={dialogButtons}
      title="Add a new Laboratory mapping"
      width="700px"
    >
      <ListFieldSection>
        <Field
          input={<LaboratoryDropdown />}
          value={choosenLaboratory}
          onChange={(evt: any) => setChoosenLaboratory(evt.data.value.value)}
          label="Laboratory"
        />
        <Field
          input={<Dropdown />}
          value={choosenAgsConfiguration}
          options={asgConfigurationListOptions}
          onChange={(evt: any) => {
            const val: ISelectOption = { value: evt.data.value.value, label: evt.data.value.label };
            setChoosenAgsConfiguration(val.value?.length ? val : null);
          }}
          label="AGS Configuration"
        />
      </ListFieldSection>
    </Dialog>
  );
};

export default AgsExportConfigurationAddLaboratoryDialogAdmin;
